var map = {
	"./": 5429,
	"./Abrafarma.png": 1545,
	"./BALTO.png": 6382,
	"./BALTObranco.png": 3540,
	"./EpocaNegocios.svg": 2646,
	"./Icon-Enviar.png": 7433,
	"./LOGO_CLINIC_FARMA_2022_2023.png": 7290,
	"./LOGO_PAGUE_MENOS.png": 7541,
	"./Pague_menos.png": 3899,
	"./Pague_menos_1.png": 3074,
	"./Path.png": 674,
	"./Shutterstock_1280457310.png": 8827,
	"./Shutterstock_1940595922.png": 2619,
	"./Shutterstock_2072813561.png": 3624,
	"./Shutterstock_2101040086.png": 3008,
	"./Shutterstock_651777256.png": 2059,
	"./Shutterstock_776025448.jpg": 9425,
	"./Shutterstock_7760254483.png": 7875,
	"./Web": 5815,
	"./Web.js": 5815,
	"./Web.scss": 4136,
	"./background-first-container.png": 7289,
	"./chatVideo.MP4": 9431,
	"./chatVideo.mp4": 8592,
	"./checklistDataSharing.png": 3506,
	"./combo-image.png": 5608,
	"./components/admin/Style": 5344,
	"./components/admin/Style.js": 5344,
	"./components/admin/admin": 7312,
	"./components/admin/admin.js": 7312,
	"./components/bnpl/Style": 1965,
	"./components/bnpl/Style.js": 1965,
	"./components/bnpl/bnpl": 217,
	"./components/bnpl/bnpl.js": 217,
	"./components/home/Style": 8351,
	"./components/home/Style.js": 8351,
	"./components/home/home": 9816,
	"./components/home/home.js": 9816,
	"./components/primaryCare/Style": 4528,
	"./components/primaryCare/Style.js": 4528,
	"./components/primaryCare/primaryCare": 2794,
	"./components/primaryCare/primaryCare.js": 2794,
	"./components/privacy/Style": 6880,
	"./components/privacy/Style.js": 6880,
	"./components/privacy/privacy": 5186,
	"./components/privacy/privacy.js": 5186,
	"./components/terms/Style": 2169,
	"./components/terms/Style.js": 2169,
	"./components/terms/terms": 1036,
	"./components/terms/terms.js": 1036,
	"./components/webFooter/Style": 9383,
	"./components/webFooter/Style.js": 9383,
	"./components/webFooter/webFooter": 7840,
	"./components/webFooter/webFooter.js": 7840,
	"./components/webHeader/Style": 1103,
	"./components/webHeader/Style.js": 1103,
	"./components/webHeader/webHeader": 4301,
	"./components/webHeader/webHeader.js": 4301,
	"./config/config": 5091,
	"./config/config.example": 145,
	"./config/config.example.json": 145,
	"./config/config.json": 5091,
	"./consent.png": 5760,
	"./consumidorModerno.png": 7446,
	"./dipirona1.png": 9669,
	"./dipirona2.webp": 8291,
	"./dipirona3.webp": 2615,
	"./dipirona4.webp": 5932,
	"./email.svg": 2084,
	"./farmaciain.png": 9089,
	"./first_second_container.png": 3061,
	"./helpers/addChat": 177,
	"./helpers/addChat.js": 177,
	"./helpers/addFeedback": 4517,
	"./helpers/addFeedback.js": 4517,
	"./helpers/auth": 7594,
	"./helpers/auth.js": 7594,
	"./helpers/bnpl": 6698,
	"./helpers/bnpl.js": 6698,
	"./helpers/getClient": 2819,
	"./helpers/getClient.js": 2819,
	"./helpers/getQuestions": 5332,
	"./helpers/getQuestions.js": 5332,
	"./helpers/listChats": 2357,
	"./helpers/listChats.js": 2357,
	"./helpers/manageCart": 8386,
	"./helpers/manageCart.js": 8386,
	"./helpers/medicine": 6528,
	"./helpers/medicine.js": 6528,
	"./helpers/mockedProducts": 6305,
	"./helpers/mockedProducts.json": 6305,
	"./helpers/postChat": 5326,
	"./helpers/postChat.js": 5326,
	"./helpers/postOnDataLake": 9069,
	"./helpers/postOnDataLake.js": 9069,
	"./helpers/sendEmail": 1240,
	"./helpers/sendEmail.js": 1240,
	"./iStock-1280292736-1.png": 7745,
	"./index": 5429,
	"./index.css": 1174,
	"./index.js": 5429,
	"./logo-extrafarma.png": 2610,
	"./output-onlinepngtools(6).png": 8339,
	"./paguemenos.png": 6677,
	"./saude_icon.png": 9061,
	"./sendEmailsList.png": 8580,
	"./serviceWorker": 4647,
	"./serviceWorker.js": 4647,
	"./spacemoney.jpeg": 9104,
	"./tosse1.webp": 5626,
	"./tosse2.png": 510,
	"./tosse3.png": 2070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;